<template>
  <div v-if="items">
    <div
      v-for="(geometry, index) in itemsToDisplay"
      :key="itemsToDisplay[index].name"
    >
      <v-row>
        <v-col>
          <v-card width="540">
            <v-card-title
              ><h5>{{ geometry.name }}</h5>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-divider></v-divider>
            <v-list dense>
              <v-list-item>
                <v-list-item-content
                  ><em>{{ 'Number of planes' }}</em></v-list-item-content
                >
                <v-list-item-content class="align-end">{{
                  geometry.numberOfPlanes
                }}</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content
                  ><em>{{
                    'Number of spacecrafts per plane'
                  }}</em></v-list-item-content
                >
                <v-list-item-content class="align-end">{{
                  geometry.numberOfSpacecraftsPerPlane
                }}</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content
                  ><em>{{ 'Altitude (km)' }}</em></v-list-item-content
                >
                <v-list-item-content class="align-end">{{
                  m2km(geometry.altitude)
                }}</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content
                  ><em>{{ 'Inclination (deg)' }}</em></v-list-item-content
                >
                <v-list-item-content class="align-end">{{
                  rad2deg(geometry.inclination)
                }}</v-list-item-content>
              </v-list-item>
              <v-list-item v-if="displayPayload(geometry)">
                <v-list-item-content
                  ><em>{{ 'Payload' }}</em></v-list-item-content
                >
                <v-list-item-content class="align-end">{{
                  geometry.payload.name
                }}</v-list-item-content>
              </v-list-item>
              <v-list-item v-if="displaySpacecraft(geometry)">
                <v-list-item-content
                  ><em>{{ 'Spacecraft' }}</em></v-list-item-content
                >
                <v-list-item-content class="align-end">{{
                  geometry.spacecraft.name
                }}</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
      <v-row></v-row>
    </div>
  </div>
</template>

<script>
import dataTools from '../../tools/data.js'

export default {
  name: 'exo-geometries-display-table',
  props: {
    items: Array
  },
  computed: {
    itemsToDisplay: function () {
      return [...new Map(this.items.map((item) => [item.name, item])).values()]
    }
  },
  methods: {
    rad2deg(value) {
      let degResult = dataTools.rad2deg(value)
      degResult = Math.round(degResult * 1e2) / 1e2
      return degResult
    },

    m2km(value) {
      return Math.round(value * 0.001 * 1e3) / 1e3
    },

    displayPayload(geometry) {
      return geometry.payload != null
    },

    displaySpacecraft(geometry) {
      return geometry.spacecraft != null
    }
  }
}
</script>
